/* No dependencies. Components reconnect automatically after Shopify editor updates. */
(() => {
  if (window.FarshOrganicSections) return;
  window.FarshOrganicSections = true;
  const key = 'farsh-organic-saved-v1';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const validEntry = entry => {
    if (!entry || !/^\d+$/.test(String(entry.id)) || typeof entry.title !== 'string' || typeof entry.url !== 'string') return false;
    try { const url = new URL(entry.url, location.origin); return url.origin === location.origin && url.pathname.includes('/products/'); } catch { return false; }
  };
  const read = () => {
    try { const parsed = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(parsed) ? parsed.filter(validEntry).slice(0, 100) : []; } catch { return []; }
  };
  let saved = read();
  const refresh = () => {
    document.querySelectorAll('.fo [data-fo-save]').forEach(button => {
      const active = saved.some(entry => String(entry.id) === button.dataset.key);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', `${active ? 'Unsave' : 'Save'} ${button.dataset.title}`);
    });
    document.querySelectorAll('.fo [data-fo-saved-count]').forEach(el => { el.textContent = String(saved.length); if (el.classList.contains('fo-count')) el.hidden = !saved.length; });
    document.querySelectorAll('fo-saved').forEach(component => component.render?.());
  };
  const persist = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); saved = next; refresh(); return true; }
    catch {
      document.querySelectorAll('.fo [data-fo-storage-status]').forEach(el => { el.textContent = 'Your browser could not save products. Check your browser storage settings.'; el.hidden = false; });
      let status = document.getElementById('fo-save-status');
      if (!status) { status = document.createElement('p'); status.id = 'fo-save-status'; status.setAttribute('role', 'status'); status.style.cssText = 'position:fixed;bottom:20px;left:20px;right:20px;z-index:9999;background:#fff;padding:20px;border:1px solid #526c50;color:#414a3c'; document.body.append(status); }
      status.textContent = 'Your browser could not save this product. Check your browser storage settings.';
      return false;
    }
  };
  class SavedProducts extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.addEventListener('click', event => {
        if (event.target.closest('[data-fo-open-saved]')) { this.render(); this.querySelector('dialog')?.showModal(); }
        if (event.target.closest('[data-fo-close-saved]')) this.querySelector('dialog')?.close();
        const remove = event.target.closest('[data-fo-remove]');
        if (remove) {
          const focusOwner = this;
          if (persist(saved.filter(item => String(item.id) !== remove.dataset.foRemove))) {
            const focusTarget = focusOwner.querySelector('[data-fo-remove]') || focusOwner.querySelector('[data-fo-close-saved]') || focusOwner.closest('details')?.querySelector('summary');
            focusTarget?.focus();
          }
        }
      }, { signal: this.abort.signal });
      this.querySelector('dialog')?.addEventListener('click', event => {
        if (event.target !== event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.currentTarget.close();
      }, { signal: this.abort.signal });
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); }
    render() {
      const list = this.querySelector('[data-fo-saved-list]'); if (!list) return;
      list.replaceChildren();
      if (!saved.length) { const li = document.createElement('li'); li.textContent = 'Save pieces you love using the heart on a product.'; list.append(li); return; }
      saved.forEach(entry => {
        const li = document.createElement('li'), a = document.createElement('a'), button = document.createElement('button');
        a.href = entry.url; a.textContent = entry.title;
        button.type = 'button'; button.dataset.foRemove = String(entry.id); button.textContent = 'Remove'; button.setAttribute('aria-label', `Remove ${entry.title}`);
        li.append(a, button); list.append(li);
      });
    }
  }
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const track = this.querySelector('[data-fo-track]'), controls = this.querySelector('.fo-carousel__controls'); if (!track) return;
      const prev = this.querySelector('[data-fo-prev]'), next = this.querySelector('[data-fo-next]');
      const update = () => {
        controls.hidden = track.scrollWidth <= track.clientWidth + 3;
        const rtl = getComputedStyle(track).direction === 'rtl';
        const offset = Math.abs(track.scrollLeft);
        prev.disabled = offset < 3; next.disabled = offset >= track.scrollWidth - track.clientWidth - 3;
        prev.setAttribute('aria-label', 'Previous products'); next.setAttribute('aria-label', 'Next products');
        this.rtl = rtl;
      };
      const move = direction => track.scrollBy({ left: direction * (this.rtl ? -1 : 1) * track.clientWidth * .88, behavior: reduced() ? 'instant' : 'smooth' });
      prev.addEventListener('click', () => move(-1), { signal: this.abort.signal });
      next.addEventListener('click', () => move(1), { signal: this.abort.signal });
      track.addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
      this.observer = new ResizeObserver(update); this.observer.observe(track); update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  }
  class BotanicalHero extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-fo-slide-button]'); if (button) this.show(Number(button.dataset.foSlideButton));
      }, { signal: this.abort.signal });
      this.addEventListener('shopify:block:select', event => {
        const slides = [...this.querySelectorAll('[data-fo-slide]')]; const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (index >= 0) this.show(index);
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
    show(index) {
      this.querySelectorAll('[data-fo-slide]').forEach((slide, i) => { slide.hidden = i !== index; });
      this.querySelectorAll('[data-fo-slide-button]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
  }
  if (!customElements.get('fo-saved')) customElements.define('fo-saved', SavedProducts);
  if (!customElements.get('fo-carousel')) customElements.define('fo-carousel', ProductCarousel);
  if (!customElements.get('fo-hero')) customElements.define('fo-hero', BotanicalHero);
  document.addEventListener('click', event => {
    const button = event.target.closest('.fo [data-fo-save]');
    if (button) {
      const found = saved.some(entry => String(entry.id) === button.dataset.key);
      const entry = { id: button.dataset.key, title: button.dataset.title, url: button.dataset.url };
      if (validEntry(entry)) persist(found ? saved.filter(item => String(item.id) !== entry.id) : [...saved.slice(-99), entry]);
    }
    document.querySelectorAll('.fo-mobile-menu[open],.fo-nav details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fo-mobile-menu[open],.fo-nav details[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { saved = read(); refresh(); } });
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
